import { FREYA_ORIENTATION_KEY } from "../../../common/constants";
import { FREYA_ORIENTATION } from "../../../common/enums";
import { useEffect } from "react";

export const useOrientationToggle = () => {
  const onOrientationChange = () => {
    let currentOrientation = localStorage.getItem(FREYA_ORIENTATION_KEY);
    if (!currentOrientation) {
      currentOrientation = FREYA_ORIENTATION.NORMAL;
    }
    const newValue = currentOrientation === FREYA_ORIENTATION.NORMAL ? FREYA_ORIENTATION.ROTATED_180 : FREYA_ORIENTATION.NORMAL;
    localStorage.setItem(FREYA_ORIENTATION_KEY, newValue);
    rotate(newValue as FREYA_ORIENTATION);
  };

  const rotate = (currentOrientation: FREYA_ORIENTATION) => {
    const el = document.getElementById("root")!;
    if (el) {
      el.style.position = "unset";
      el.style.transform = `rotate(${currentOrientation === FREYA_ORIENTATION.NORMAL ? "0" : "180deg"})`;
      el.style.transformOrigin = `${currentOrientation === FREYA_ORIENTATION.NORMAL ? "unset" : "50% 51%"}`;
    }

    const header = document.getElementsByTagName("header")[0];
    if (header) {
      header.scrollIntoView({ behavior: "smooth" });
      header.style.top = `${currentOrientation === FREYA_ORIENTATION.NORMAL ? "0" : "unset"}`;
    }

    if (window.location.pathname === "/freya" && el) {
      el.style.transformOrigin = `${currentOrientation === FREYA_ORIENTATION.NORMAL ? "unset" : "50% 50%"}`;
      el.style.position = "absolute";
      el.style.width = "100%";
      el.style.height = "100%";
    }
  };

  useEffect(() => {
    rotate((localStorage.getItem(FREYA_ORIENTATION_KEY) as FREYA_ORIENTATION) || FREYA_ORIENTATION.NORMAL);
  }, []);

  return { onOrientationChange };
};
